export const resolveChapterRoot = (container: ParentNode, chapterId: string): HTMLElement | null => {
  const escaped = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(chapterId) : chapterId;
  const selectors = [
    `[data-chapter-slot-id="${escaped}"] > [data-chapter-id="${escaped}"]`,
    `[data-chapter-id="${escaped}"][role="doc-chapter"]`,
    `#${escaped}`,
    `[id="chapter-${escaped}"]`,
    `[id="chap-${escaped}"]`,
  ];

  for (const selector of selectors) {
    const node = container.querySelector(selector);
    if (node && node.nodeType === 1) {
      return node as HTMLElement;
    }
  }

  return null;
};
